import axios from "axios";
import config from "../config/config";
import { utils } from "../utils/utils";

const handleError = (err) => {
  if (err?.response?.status === 401) {
    window.location.href = `/auth/sign-in?returnURL=${window.location.pathname}`;
  } else if (err?.response?.status === 404) {
    window.location.href = "/error/404";
  } else if (err?.response?.status === 400 || err?.response?.status === 422) {
    throw err;
  } else {
    window.location.href = "/error/500";
  }
};

export const investorDistributionsApi = {
  getDistributions: (data) => {
    const query = utils.generateQueryString(data);
    return axios(`/api/investor-distributions?${query}`, {
      baseURL: config.apiURL,
      withCredentials: true,
      method: "get",
    })
      .then((result) => result.data)
      .catch((err) => handleError(err));
  },
  createDistribution: (data) =>
    axios(`/api/investor-distributions`, {
      baseURL: config.apiURL,
      withCredentials: true,
      method: "post",
      data,
    })
      .then((result) => result.data)
      .catch((err) => handleError(err)),
  updateDistribution: (data) =>
    axios(`/api/investor-distributions/${data.id}`, {
      baseURL: config.apiURL,
      withCredentials: true,
      method: "put",
      data,
    })
      .then((result) => result.data)
      .catch((err) => handleError(err)),
  updatePaidAllDistributions: (data) =>
    axios(`/api/investor-distributions/paid-all`, {
      baseURL: config.apiURL,
      withCredentials: true,
      method: "post",
      data: { paid: data.paid, ids: data.ids },
    })
      .then((result) => result.data)
      .catch((err) => handleError(err)),
  deleteDistributions: (data) =>
    axios(`/api/investor-distributions/${data.id}`, {
      baseURL: config.apiURL,
      withCredentials: true,
      method: "delete",
    })
      .then((result) => result.data)
      .catch((err) => handleError(err)),
};
